<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialogOpen" persistent max-width="600px">
      <v-toolbar dark color="primary" height="45">
        <v-toolbar-title>User Settings</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn small icon color="primary" @click="$emit('input', false)">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-tabs>
        <v-tab>
          <v-icon>account_circle</v-icon>
          General
        </v-tab>
        <v-tab-item>
          <v-card>
            <v-container fluid grid-list-sm class="py-2">
              <v-layout row wrap>
                <v-text-field :value="currentUsername" label="Email" readonly />
                <v-text-field :value="currentRole" label="Role" readonly /> </v-layout
            ></v-container>
            <v-container>
              <v-layout row wrap>
                Modules:
                <v-chip filter small v-for="module in markets" :key="module">{{ module }} </v-chip>
              </v-layout>
            </v-container>
          </v-card>
        </v-tab-item>
        <v-tab>
          <v-icon>lock</v-icon>
          Change Password
        </v-tab>
        <v-tab-item>
          <v-card>
            <v-form @submit.prevent="changePassword" ref="form">
              <v-container fluid grid-list-sm class="py-2">
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      xs12
                      v-model="currentPassword"
                      :type="'password'"
                      label="Current Password"
                      required
                      :rules="[v => !!v || 'Password is required']"
                    ></v-text-field>
                    <v-text-field
                      v-model="newPassword"
                      :type="'password'"
                      label="New Password"
                      required
                      :rules="[v => !!v || 'Password is required']"
                    ></v-text-field>
                    <v-text-field
                      v-model="newPasswordConfirm"
                      :type="'password'"
                      label="Confirm New Password"
                      required
                      :rules="[
                        v => !!v || 'Password is required',
                        v => v === newPassword || 'Password must match',
                      ]"
                    ></v-text-field>
                  </v-flex>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-btn type="submit">Change</v-btn>
                  </v-card-actions>
                </v-layout></v-container
              >
            </v-form>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-dialog>
  </v-layout>
</template>

<script>
import notification from '../../helpers/notification'
import {mapGetters} from 'vuex'

export default {
  model: {prop: 'visible', event: 'input'},
  props: {
    visible: {type: Boolean, required: true},
  },
  computed: {
    dialogOpen: {
      get() {
        return this.visible
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
    ...mapGetters('authentication', ['currentUsername', 'currentRole']),
    ...mapGetters('app', ['markets']),
  },
  data() {
    return {
      currentPassword: null,
      newPassword: null,
      newPasswordConfirm: null,
    }
  },
  methods: {
    async changePassword() {
      if (!this.$refs.form.validate()) return
      const {currentPassword, newPassword} = this
      const {message, success} = await this.$store.dispatch('authentication/changePassword', {
        currentPassword,
        newPassword,
      })

      notification(message, success ? 'info' : 'error')

      if (success) {
        this.$refs.form.reset()
      }
    },
  },
}
</script>
